import { Breakpoint } from '../../../BaseComponents/ThemeProvider/AvenyTheme';
import { TVisningstyp } from '../_Common/Components/BusinessCollectionComponents/BusinessDataSet/BusinessDataSet';
import { IRutinSettingsContext } from '../_Common/Components/RutinAvailabilityContext/RutinAvailabilityContext';
import { rutiner } from '../_Common/Const/Rutiner';
import { styrvarden } from '../_Common/Const/Styrvarden';

export const getDefaultVisningsTyp = (
  screenWidth: Breakpoint,
  inCard: boolean,
  rutinKod: string
): TVisningstyp => {
  const config = rutiner[rutinKod] ?? styrvarden()[rutinKod];
  const defaultShowDetailsRight = config?.defaultShowDetailsRight;
  const defaultVisningsTyp = config?.defaultVisningsTyp;

  if (
    defaultVisningsTyp !== 'kalender' &&
    defaultVisningsTyp !== 'bisattningStart'
  ) {
    if (inCard) {
      return 'lista';
    } else {
      return screenWidth === 'xs' || screenWidth === 'sm'
        ? 'kort'
        : defaultVisningsTyp === undefined
        ? defaultShowDetailsRight
          ? 'lista'
          : 'tabell'
        : defaultVisningsTyp;
    }
  }
  return defaultVisningsTyp;
};

export const getVisningsTyp = (
  rutinAvailabilityContext: IRutinSettingsContext,
  rutinID: number,
  collectionName: string,
  screenWidth: Breakpoint,
  inCard: boolean,
  rutinKod: string,
  selectedLayoutVisningstyp?: TVisningstyp
): TVisningstyp => {
  const rutinContextValue =
    rutinAvailabilityContext.settings[rutinID]?.visningsTyper?.[collectionName];

  if (rutinContextValue) {
    return rutinContextValue;
  } else if (selectedLayoutVisningstyp) {
    return selectedLayoutVisningstyp;
  } else {
    return getDefaultVisningsTyp(screenWidth, inCard, rutinKod);
  }
};
